import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Minimal shared flag marking that a business switch is mid-flight.
 *
 * Extracted from BusinessContextService so the RouteReuseStrategy can read it
 * without injecting BusinessContextService (which injects Router) — that would
 * form a Router → RouteReuseStrategy → BusinessContextService → Router cycle.
 * The shell subscribes to `switching$` for the switch loading treatment.
 */
@Injectable({ providedIn: 'root' })
export class BusinessSwitchState {
	private readonly switchingSubject = new BehaviorSubject<boolean>(false);

	public readonly switching$: Observable<boolean> = this.switchingSubject.asObservable();

	public get switching(): boolean {
		return this.switchingSubject.value;
	}

	public begin(): void {
		this.switchingSubject.next(true);
	}

	public end(): void {
		this.switchingSubject.next(false);
	}
}
